/**
 * Storage Abstraction Layer — Entry Point
 * Sprint 1, Story 1.4 / Ativado MinIO 2026-09-14
 */

export type { StorageProvider, StorageBucket, StorageUploadResult, StorageSignedUrlResult } from './types';
export { expressStorageAdapter } from './express-adapter';

import { expressStorageAdapter } from './express-adapter';
import type { StorageProvider } from './types';

// Adapter ativo: MinIO via /api/storage/* (Express). O do Supabase ficou ativo
// até 2026-09-14 apontando para localhost:54321 em produção — nenhum upload de
// foto, anexo ou comprovante funcionava (CLAUDE.md §7.6).
export const storage: StorageProvider = expressStorageAdapter;
